import { ClientEntity, RepresentativeClientEntity } from 'api/types/entity';
import { parseFullName } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { usePageTitle } from 'libs/navigation';

export const useClientPageTitle = (
  client: ClientEntity | null,
  representativeClient: RepresentativeClientEntity | null
) => {
  const { t } = useTranslation();

  let fullName = representativeClient
    ? t('client.representativeClient.title', {
        name: parseFullName(representativeClient),
      })
    : '';

  fullName += fullName && client ? ` - ${parseFullName(client)}` : '';

  usePageTitle(fullName);
};
